import Action from "./email-channel-action-field";
import Info from "./email-channel-info-field";
import Status from "./email-channel-status-field";
import Visibility from "./email-channel-visibility-field";

const EmailChannelFields = { Action, Info, Status, Visibility };

export default EmailChannelFields;
